import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElDatePicker, ElButton, FormInstance, ElSelect, ElTag } from 'element-plus';
    import { Travel, TravelCompany } from '@/services/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TripsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const trips = ref<Array<Travel>>([])
    const companies = ref<Array<TravelCompany>>([])
    const formRef = ref<FormInstance>()

    const searchData = reactive<{travel_company_id: number, dates: Array<string>}>({travel_company_id: 0, dates: []})

    const getCompanies = async () => {
        const res = await Api.get(`admin/travel-companies`)
        if (res.status == 200) {
            console.log(res.data)
            companies.value = res.data.companies
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    
    const getTrips = async (id: number | false | null = 0, dates: Array<string> | undefined | false = false) => {
        const params = new URLSearchParams()
        if (id && id > 0) {
            params.append('travel_company_id', id.toString())
        } 
        if (dates) {
            params.append('start', new Date(dates[0]).toISOString())
            params.append('end', new Date(dates[1]).toISOString())
        }
        const res = await Api.get(`admin/travel?${params.toString()}`)
        if (res.status == 200) {
            console.log(res)
            trips.value = res.data.travel
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }

    const search = async () => {
        loading.value = true
        await getTrips(searchData.travel_company_id, searchData.dates)
        loading.value = false
    }
    
    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getTrips(),
            getCompanies()
        ])
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Eventos" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          "label-position": "top",
          inline: "",
          model: searchData
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              label: "Datas das viagens",
              class: "col-12 col-md-5 col-lg-4",
              prop: "dates"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElDatePicker), {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Desde",
                  "end-placeholder": "Até",
                  modelValue: searchData.dates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchData.dates) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), { label: "buscar" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Procurar viagens", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 400,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
            ],
          data: trips.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Data e hora de partida",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.departure).toLocaleString("af")) + " ", 1),
                _createVNode(_unref(ElTag), {
                  type: new Date(data.row.departure) < new Date() ? 'danger':'success'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(new Date(data.row.departure) < new Date() ? 'Realizada':'Disponivel'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Empresa",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.car.travel_company.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Carro",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.car.name) + " [" + _toDisplayString(data.row.car.plate) + "] ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Rota de viagem",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.route.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    tag: "router-link",
                    to: '/travel/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})